module.exports = __webpack_public_path__ + "img/avax.c429a3bb.png";